export default __webpack_public_path__ + "static/media/cosmetics.2012f851.svg";